import React from "react";

import { GenericSwitch } from "components";
import { FeeTemplateQueue } from "globalConstants";
import { TableCellProp, User } from "types";

import styles from "../feeTemplatesQueue.module.scss";

type ActiveColumnProps = {
	handleSetDefault: Function;
	handleSetStatus: Function;
	isLoading: boolean;
};

const { IsDefault, IsActive, TemplateId } = FeeTemplateQueue;

const ActionSwitchColumn = ({
	handleSetDefault,
	handleSetStatus,
	isLoading,
}: ActiveColumnProps) => ({
	accessor: "id",
	disableSortBy: true,
	classNameCell: styles.feeTemplateCell,
	Cell: ({ row: { original } }: TableCellProp<User>) => {
		const isDefault = original?.[IsDefault.name];
		const isActive = original?.[IsActive.name];
		const templateId = original?.[TemplateId.name];

		return (
			<div className={styles.actionSwitchHolder}>
				<div className={styles.actionSwitch}>
					<GenericSwitch
						id={`${templateId}-activeStatus`}
						name={`${templateId}-activeStatus`}
						enabled={isActive}
						onChange={() => handleSetStatus(templateId, !isActive)}
						isDisabled={isDefault}
						isReadOnly={isLoading}
					/>
					<div className={styles.actionSwitchText}>
						{isActive ? "Available" : "Unavailable"}
					</div>
				</div>
				<div className={styles.actionSwitch}>
					<GenericSwitch
						id={`${templateId}-isDefault`}
						name={`${templateId}-isDefault`}
						enabled={isDefault}
						onChange={() =>
							handleSetDefault(templateId, !isDefault)
						}
						isDisabled={!isActive || isDefault}
						isReadOnly={isLoading}
					/>
					<div className={styles.actionSwitchText}>Default</div>
				</div>
			</div>
		);
	},
});

export default ActionSwitchColumn;
